export enum FilterSelectorStorageKey {
    Fee = 'fee',
    Invoice = 'invoice',
}
